import authApi from "api/auth";
import directUploadApi from "api/directUpload";
import { IApi } from "config/types";

const api: IApi = {
  auth: authApi,
  directUpload: directUploadApi,
};

export default api;
